import { Summary } from 'model/Summary';
import { summaryMapper } from 'container/summaryMapper';
import { BenchmarkType } from 'model/BenchmarkType';
import { components } from 'type/ReportServiceSchema';
import { SummaryApi } from 'api/SummaryApi';
import dayjs, { Dayjs } from 'dayjs';
import { OpinionQuestion } from 'model/OpinionQuestion';
import { OpinionQuestionDetails } from 'model/OpinionQuestionDetails';
import { CategoryItemModel, mapCategoryItemDtoToModel } from 'api/dto/new/Common/CategoryItem.dto';
import { Trend } from 'model/Trend';

export type SummaryPulseCombinedDto = components['schemas']['SummaryPulseCombinedReportResultDTO'];

export type SummaryPulseCombinedModel = {
  byCategory: ReadonlyArray<CategoryItemModel>;
  showImpactOnEngagement: boolean;
  summary: Summary.Combine;
  closedAtDate: Dayjs;
};

// export type SummaryPulseCombinedModel = {
//   byCategory: ReadonlyArray<CategoryItemModel>;
//   showImpactOnEngagement: boolean;
//   summary: SummaryItemWithBenchmarkAndTrendModel;
//   closedAtDate: Dayjs;
// };

// TODO: use this mapper later for new endpoint proper typing - https://buzzing.atlassian.net/browse/RPT-415
// export const mapSummaryPulseCombinedDtoToModel = (
//   dto: SummaryPulseCombinedDto
// ): SummaryPulseCombinedModel => ({
//   byCategory: dto.byCategory.map(mapCategoryItemDtoToModel),
//   showImpactOnEngagement: dto.showImpactOnEngagement,
//   summary: mapSummaryItemWithBenchmarkAndTrendDtoToModel(dto.summary),
//   closedAtDate: dayjs(dto.closedAtDate),
// });

export const mapSummaryPulseCombinedDtoToModel = (
  dto: SummaryPulseCombinedDto
): SummaryPulseCombinedModel => {
  const summaryEntry: SummaryApi.EntryCombine = {
    score: dto.summary.score,
    benchmark: {
      ...dto.summary.benchmark,
      type: dto.summary.benchmark.type as BenchmarkType,
    },

    trends: dto.summary.trends,
    responseRate: dto.summary.responseRate,
  };

  return {
    byCategory: dto.byCategory.map(mapCategoryItemDtoToModel),
    showImpactOnEngagement: dto.showImpactOnEngagement,
    summary: summaryMapper.deserializeCombine(summaryEntry),
    closedAtDate: dayjs(dto.closedAtDate),
  };
};

// Mapper to convert SummaryPulseCombined byCategory to OpinionQuestion.Combine format
// for engagement drivers slice compatibility
export const mapSummaryPulseCombinedToEngagementDrivers = (
  model: SummaryPulseCombinedModel
): OpinionQuestion.Combine[] => {
  return model.byCategory.map(
    (category): OpinionQuestion.Combine => ({
      score: category.score || 0,
      benchmark: category.benchmark,
      category: category.category
        ? {
            id: category.category.id,
            name: category.category.name,
            connectedId: category.category.connectedId ?? null,
          }
        : undefined,
      trends: category.trends,
      details: category.details.map(
        (detail): OpinionQuestionDetails.Combine => ({
          score: detail.score || 0,
          question: detail.question,
          feedback:
            detail.feedback?.map((fb) => ({
              label: fb.label,
              value: fb.value,
              options: fb.options?.slice(0, 2) as [string] | [string, string] | undefined,
            })) || [],
          trends: detail.trends.map((trend: Trend) => {
            return {
              ...trend,
              askedAt: detail.trendQuestion?.askedAt
                ? dayjs(detail.trendQuestion.askedAt)
                : undefined,
            };
          }),
          benchmark: detail.benchmark,
          impactOnEngagement: detail.impactOnEngagement,
          impactOnEngagementScore: detail.impactOnEngagementScore,
        })
      ),
    })
  );
};
